import { render, staticRenderFns } from "./VideoEventDisplay.vue?vue&type=template&id=1c53b839"
import script from "./VideoEventDisplay.vue?vue&type=script&lang=js"
export * from "./VideoEventDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports